export default {
  custom_option: 'Personalizado',
  zero_option: 'Sem gorjeta',
};
